import { vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["placeholder", "autofocus", "disabled", "spellcheck"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "n-textarea-autosize__description label-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("textarea", _mergeProps(_ctx.$attrs, {
      class: ['n-textarea-autosize', { 'label-mono-m': _ctx.mono, 'label-m': !_ctx.mono }],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.areaValue) = $event)),
      placeholder: _ctx.placeholder,
      autofocus: _ctx.autofocus,
      disabled: _ctx.disabled,
      ref: "area",
      rows: "1",
      style: { height: _ctx.height ? `${_ctx.height}px` : 'auto' },
      spellcheck: _ctx.spellcheck,
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur')))
    }), null, 16, _hoisted_1), [
      [_vModelText, _ctx.areaValue]
    ]),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}